<template>
  <div class="flex flex-wrap">


    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm"
      >Quantity</label>

      <input class="w-full bge-input bge-input-spacing rounded" v-model="quantity"
             type="text"/>
    </div>

    <div class="w-full py-2">
      <label class="block uppercase font-semibold text-sm mb-1">Boston Code / Product Description</label>
      <ProductAutoComplete
          class="w-full add-product-autocomplete"
          v-model="autocompleteSelection"
          @productSelected="onPickFromAutocomplete"
          @productCleared="onClearAutocomplete"
      />
    </div>
    <div class="w-full py-2">
      <Products :searchTerm="productSearchTerm" :customerPriceBand="customerPriceBand" @productSelected="handleProductSelected"></Products>
    </div>

    <div class="bg-gray-100 p-4 rounded text-sm text-secondary">
      <p class="font-semibold ">NOTE:</p>
      <p>USE THE FOLLOWING CODES FOR ORDERING NON-DATABASE ITEMS AND EDIT THE ITEM DESCRIPTION AS REQUIRED:</p>
      <ul class="list-none pl-4">
        <li><span class="font-semibold">SPC1</span> - GENERAL SPARE PARTS ORDER</li>
        <li><span class="font-bold">SPC2</span> - GENERAL EQUIPMENT ORDER</li>
        <li><span class="font-bold">SPC3</span> - GENERAL OFFICE SUPPLIES ORDER</li>
        <li><span class="font-bold">SPC4</span> - MISCELLANEOUS ITEMS</li>
      </ul>
    </div>

  </div>
</template>

<script>

import notificationMixin from "@/mixins/notificationMixin";
import Icon from "@/components/Icon.vue";
import Products from "@/views/HR/Sales/Components/Products.vue";
import ProductAutoComplete from "@/components/AutoComplete/ProductAutoComplete.vue";


export default {
  name: "FindEquipment",
  mixins: [notificationMixin],
  components: {
    Products,
    Icon,
    ProductAutoComplete,
  },
  props: {
    customerPriceBand: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      quantity: 0,
      autocompleteSelection: null,
      productSearchTerm: '',
      tax_codes: [],
    };
  },
  async mounted() {
    await this.fetchDataMasterTaxCodes();
  },
  methods: {

    onPickFromAutocomplete(event) {
      const picked = event && event.value ? event.value : event;
      const code = picked && picked.product_code ? picked.product_code : '';
      this.productSearchTerm = code;
    },
    onClearAutocomplete() {
      this.productSearchTerm = '';
      this.autocompleteSelection = null;
    },
    handleProductSelected(product) {
      const picked = this.resolveTaxForProduct(product);

      const productWithQuantity = {
        ...product,
        quantity: this.quantity,
        description: (product && product.name) || '',
        supplier_product_code: (product && product.supplier_product_code) || '',
        tax_code: picked.tax_code || 'default_tax_code',
        tax_rate: picked.tax_rate || 0,
        tax_codes: this.tax_codes || [],
      };

      this.$emit("complete", productWithQuantity);
    },

    resolveTaxForProduct(product) {
      // Match Product Details: it stores the VAT Code data master's `description`
      // on product.vat_code. Look up by description first, then fall back to a
      // 20% standard entry, then to the first entry in the data master.
      const list = this.tax_codes || [];

      const byDescription = product && product.vat_code
          ? list.find(t => t.description === product.vat_code)
          : null;

      const standard = list.find(t => parseFloat(t.value) === 0.2);
      const fallback = byDescription || standard || list[0] || null;

      if (!fallback) return { tax_code: null, tax_rate: 0 };
      return {
        tax_code: fallback.name,
        tax_rate: parseFloat(fallback.value) || 0,
      };
    },

    async fetchDataMasterTaxCodes() {
      try {
        const response = await this.DatamasterService.getDataMasters('?noPaging=true&type=PO_Tax_Code&is_active=true&orderBy=name&order=1');
        this.tax_codes = response.map(item => ({
          data_master_id: item.data_master_id,
          name: item.name,
          description: item.description || '',
          value: item.value || '',
        }));
      } catch (error) {
        console.error('Error fetching data master certificates:', error);
      }
    },

  },
};
</script>

<style scoped>
::v-deep .add-product-autocomplete {
  display: block;
  width: 100%;
}
::v-deep .add-product-autocomplete .p-autocomplete-input,
::v-deep .add-product-autocomplete input.p-inputtext {
  width: 100%;
}
</style>
